import React, {useEffect, useState} from "react";
import {Dialog, DialogActions, DialogContent, DialogTitle, Stack, Step, StepLabel, Stepper} from "@mui/material";
import {Box} from "@mui/system";
import ButtonBack from "../../../button/ButtonBack";
import ButtonExit from "../../../button/ButtonExit";
import ButtonAdd from "../../../button/ButtonAdd";
import TextFieldValidation from "../../customer-detales/TextFieldValidation";
import DetailReserve from "../../../../../pages/organization/DetailReserve";

const ModalAddToWarehouse = ({
                                 open,
                                 onClose,
                                 handleSubmit,
                                 initValue
                             }) => {
    const [formState, setFormState] = useState({count: "0"})
    const [activeStep, setActiveStep] = useState(0)
    const [selectedString, setSelectedString] = useState({})

    useEffect(() => {
        setFormState({count: initValue?.quantity})
    }, [open]);

    const close = () => {
        onClose()
        setActiveStep(0)
        setSelectedString({})
    }
    const submit = () => {
        if (activeStep === 0 && !initValue?.id) {
            setActiveStep(1)
        } else {
            handleSubmit(close, formState, selectedString)
        }
    }
    return (
        <Dialog open={open} PaperProps={{
            style: {
                minWidth: `${(activeStep === 0 && !initValue?.id) ? "1600px" : "300px"}`,
            }
        }}>
            <DialogTitle textAlign="center">{initValue?.id ? "Изменить количество" : "Добавить деталь"}</DialogTitle>

            <Box sx={{display: "flex", justifyContent: "center"}}>
                {!initValue?.id && <Stepper
                    style={{width: 400}}
                    activeStep={activeStep}
                >
                    {["Резервы деталей", "Количество"].map((label) => (
                        <Step key={label}>
                            <StepLabel sx={{
                                ".MuiSvgIcon-root": {
                                    fontSize: 40,
                                    color: "#737478",
                                    "&.Mui-active": {
                                        color: "#3B8BEC",
                                    }
                                },
                                "& .MuiStepLabel-label": {
                                    fontSize: 18,
                                    "&.Mui-active": {
                                        fontWeight: 700,
                                    }
                                }
                            }}>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>}
            </Box>
            <DialogContent>
                {(activeStep === 0 && !initValue?.id && open) ? <DetailReserve
                        isModal={true}
                        selectedString={selectedString}
                        setSelectedString={setSelectedString}
                    /> :
                    <form onSubmit={(e) => e.preventDefault()}>
                        <Stack
                            sx={{
                                width: '100%',
                                minWidth: {xs: '300px', sm: '360px', md: '400px'},
                            }}
                        >
                            <TextFieldValidation
                                name="count"
                                label="Количество"
                                type="number"
                                value={formState.count}
                                setCurrValues={setFormState}
                            >
                            </TextFieldValidation>
                        </Stack>
                    </form>}
            </DialogContent>
            <DialogActions style={{padding: 40, display: "flex", justifyContent: "space-between"}}>
                <Box>{activeStep !== 0 && <ButtonBack text={"Назад"} onClick={() => setActiveStep(0)}/>} </Box>
                <Box>
                    <ButtonExit
                        text={"Выйти"} onClick={close}/>
                    <ButtonAdd
                        text={initValue?.id ? "Изменить" : (activeStep === 0) ? "Выбрать" : "Добавить"}
                        onClick={submit}
                        disabled={!selectedString?.id && !initValue?.id}
                    />
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default ModalAddToWarehouse;